<template>
  <div class="data-table">
    <el-card>
      <div slot="header" class="clearfix">
        <span>{{$t('instrData.instrData')}}</span>
      </div>
      <div class="btn-box">
        <!-- <el-button type="primary" icon="el-icon-plus" size="mini"  @click="editDevice(null,false)">新建</el-button> -->
        <div></div>
        <div class="sw-btn">
          <p>显示数据</p>
          <el-switch
            v-model="switchValue"
            @change="switchChange"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </div>
      </div>
      <div class="t_btn2">
        <el-table
          :data="tableData"
          :empty-text="empty"
          highlight-current-row
          ref="multipleTable"
          height="calc(100vh - 135px)"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{backgroundColor:'transparent',color:'#fff',fontSize:'14px',textAlign:'left',fontWeight: '500', borderBottom: '1px solid rgba(255, 255, 255, .5)', padding: '0'}"
          :cell-style="{color: 'rgba(255,255,255)',backgroundColor:'transparent',fontSize:'14px',textAlign:'left',padding: '5px 0',borderBottom: '1px solid rgba(255, 255, 255, 0.1)'}"
          :row-style="{color: '#ccc',backgroundColor:'transparent',fontSize:'13px',textAlign:'left'}"
        >
          <el-table-column prop="name" :label="$t('instrData.name')">
            <template slot="header">
              <div style="display:flex;justify-content: space-between;">
                <p>名称</p>
                <p>数值</p>
              </div>
            </template>
            <template slot-scope="scope">
              <div
                @click="selectPos(scope.row, 'single')"
                style="cursor: pointer; display:flex;justify-content: space-between;"
              >
              <p>{{scope.row.deviceName}}</p>
              <p>{{scope.row.qValue+(scope.row.unit||'')}}</p>
              </div>
              <div style="font-size:10px;line-height:15px;color:rgba(255,255,255,.75)">{{scope.row.tagDes}}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="QValue" :label="$t('instrData.val')" width="90">
            <template slot-scope="scope"></template>
          </el-table-column> -->
          <el-table-column :label="$t('instrData.status')" align="center" width="50">
            <template slot-scope="scope">
              <span :class="{'circ':true,'circ-b':getStatus(scope.row)}"></span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="50">
            <template slot-scope="scope">  
              <el-popover
                placement="bottom"
                trigger="hover">
                <div class="pop-cont">
                  <el-link :underline="false" type="primary" @click="openChart(scope.row)"><i class="iconfont iconicon_chart"></i>动态趋势图</el-link>
                  <el-link :underline="false" type="primary" @click="setWarnVal(scope.row)"><i class="iconfont iconicon_set_up"></i>警报设置</el-link>
                  <!-- <el-link :underline="false" type="primary" @click="deleteDevice(scope.row)"><i class="iconfont iconicon_del"></i>删除</el-link> -->
                </div>
                <el-link :underline="false" slot="reference" type="primary"><i class="iconfont iconicon_list"></i></el-link>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import ApiService from "@/services/API-services"
export default {
  name: "dataMonitorTable",
  data() {
    return {
      dataval: null,
      isEdit: false,
      data: null,
      currentSelectDevice: null,
      selected: false,
      showLinkBtn: false,
      types: [],
      values: [],
      tableData: [],
      monitorType: null,
      monitorValue: null,
      show: false,
      selectTag: [],
      perList: [],
      empty: this.$t("menu.jzz"),
      columnNum: 100,
      switchValue: false
    };
  },
  created() {
    this.perList = this.$store.state.perList
    this.initTags()
  },
  watch: {
    switchValue: {
      handler: function(val) {
        this.switchValue = val
        if (!val) {
          this.hideAllTag()
        } else {
          this.showAllTag()
        }
      },
      deep: true
    }
  },
  mounted() {
    clearInterval(this.timer);
    this.setTimer();
  },
  destroyed() {
    if (!this.switchValue) {
      clearInterval(this.timer)
    }
  },
  methods: {
    switchChange(val){
      this.$store.commit('setMeterStatus', val)
    },
    getStatus(row) {
      if (
        parseFloat(row.QValue) < parseFloat(row.OfflineValues) ||
        parseFloat(row.QValue) > parseFloat(row.OnlineValue)
      ) {
        return true;
      } else {
        return false;
      }
    },
    resetSelected() {
      this.selected = false;
      this.showLinkBtn = false;
      this.currentSelectDevice = null;
    },
    openChart(row) {
      this.$store.commit('setEqData', row)
      // this.$store.state.eqData = row;
      this.$store.commit("showModal", {
        name: "eqChart",
        show: true,
        left: "",
        top: "1rem",
        data: row
      });
    },
    setWarnVal(row) {
      this.$store.commit("showModal", {
        name: "eqValEdit",
        show: true,
        left: "",
        top: "2.5rem",
        data: row
      });
    },
    editDevice(row, isedit) {
      this.$store.commit("showModal", {
        name: "dataMonitor",
        show: true,
        left: "",
        top: "2.5rem",
        data: row
      });
      this.isEdit = isedit;
      this.currentSelectDevice = row;
    },
    // 显示所有标签
    showAllTag() {
      // window.resetView();
      this.hideAllTag();
      // console.log(this.tableData)
      this.tableData.forEach((res, index) => {
        this.selectPos(res, "mutiple", index);
      });
    },
    hideAllTag() {
      window.ResetAllElement();
      window.markerArray.forEach(ele => {
        window.RemoveMarker(ele);
      });
      window.markerArray = [];
      this.selectTag = [];
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.currentSelectDevice && row.ID === this.currentSelectDevice.ID) {
        return "warning-row";
      }
      return "";
    },
    selectDevice(row) {
      this.selected = true;
      this.currentSelectDevice = row;
      this.getdevicelist();
      this.$emit("showViewClick", "show2");
    },
    deleteDevice(obj) {
      ApiService.tree
        .deletedevice({
          id: obj.id,
          mileageID: window.R_config.modelId
        })
        .then(res => {
          if (res.code == 0) {
            this.$message({
              message: this.$t("menu.sccg"),
              type: "success"
            });
            this.getdevicelist();
          }
        });
    },
    initTags() {
      ApiService.tree
        .devicelist({
          mileageID: window.R_config.modelId,
          page: 1,
          linit: 20,
          Type: 2
        })
        .then(res => {
          if (res.code == 0) { 
            this.tableData = res.data
            if (this.switchValue) {
              res.data.forEach((res, index) => {
                this.selectPos(res, "mutiple", index)
              })
            }
          } else {
            this.empty = this.$t("docMgt.noData");
          }
        });
    },
    getdevicelist() {
      ApiService.tree
        .devicelist({
          mileageID: window.R_config.modelId,
          page: 1,
          linit: 50,
          Type: 2
        })
        .then(res => {
          if (res.code == 0) {
            this.tableData = res.data;
          } else {
            this.empty = this.$t("docMgt.noData");
          }
        });
    },
    selectPos(row, type, index) {
      ApiService.doc
        .getModelData({
          glid: "",
          bitNumber: row.deviceName,
          mileageID: window.R_config.modelId
        })
        .then(res => {
          if (res.code !== 0 && type === "single") {
            this.$message({
              message: "无设备数据",
              type: "warn"
            })
            return
          }
          if (res.code === 0) {
            let glids = ""
            if (res.data.glid.length > 1) {
              glids = res.data.glid.join("#")
            } else {
              glids = res.data.glid[0]
            }
            window.elementType = 0
            window.clickGlids = glids
            window.currentElement = glids
            this.addLabel(row, glids, type, index, res.data.angelCode)
            if (type === 'single') {
              this.getproperty(row.deviceName)
            }
          }
        });
    },
    getproperty(bit) {
      window.Muster = bit;
      ApiService.tree
        .property({
          mileageID: window.R_config.modelId,
          BitNumber: bit
        })
        .then(res => {
          if (res.code == 0) {
            let attrData = res.data;
            this.$store.commit("syncAttrData", attrData);
          }
        });
    },
    addLabel(row, glids, type, index, angel) {
      // window.SetElementColor(glids, 255, 0, 0);
      if (type === "single") {
        window.ResetAllElement()
        if (window.markerArray.length > 0) {
          for (var i = 0; i < window.markerArray.length; i++) {
            window.RemoveMarker(window.markerArray[i]);
          }
          window.markerArray.shift();
        }
        if (angel) {
          window.StartViewAnimation([window.GetView(), angel], 5000)
        } else {
          window.FlyTo(glids, true, 2.8);
        }
        SetElementColor(glids, 255, 0, 0)
        this.$store.commit('showModal', {
          name: 'attrs',
          show: true,
          left: '',
          right: '0',
          data: null
        })
      }
      let htmlStr = `<div id="tips_show" style="top: ${index%2 == 0 ? '' : '-188px'}" class='tips_show' onclick="onLabelClick('${row.deviceName.trim()}')">
                    <div class="tip-icon" style="background:${this.getStatus(row) ? '#F07150' : '#4ACA8A'}">
                      <i class="iconfont ${row.unit === 'kpa' ? 'iconicon_pressure' : 'iconicon_temperature'}"></i>
                    </div>
                    <div class="tip-cont">
                      <p id='deviceName_${row.id}'>${row.deviceName}</p>
                      <p class="p-value" id='qValue_${row.id}'>${row.qValue}${row.unit || ""}</p>
                    </div>
                    <span class="line" style="background:${this.getStatus(row) ? '#F07150' : '#4ACA8A'};height:${index%2 == 0 ? '' : '164px'}"></span>
                    </div>`
      window.currentPos = window.GetCenterById(glids);
      window.clickGlids = glids;
      window.AddHtmlMarker(
        window.currentPos,
        htmlStr,
        "marker" + window.markerArray.length
      );
      window.markerArray.push("marker" + window.markerArray.length);
      this.selectTag.push(row.ID);
    },
    cancle() {
      this.show = !this.show;
    },
    setTimer() {
      this.timer = setInterval(() => {
        this.getdevicelist();
        this.showDetail();
      }, 1000);
    },
    showDetail() {
      this.tableData.map(res => {
        if (this.$store.state.eqData && res.ID == this.$store.state.eqData.ID) {
          this.$store.state.eqData = res;
        }
        this.selectTag.map(item => {
          if (item == res.ID) {
            var _obj = document.getElementById("qValue_" + res.ID);
            if (_obj) {
              document.getElementById("qValue_" + res.ID).innerText =
                res.QValue + (res.Unit || "");
            }
          }
        });
      });
    }
  }
};
</script>

<style lang="scss">
@import '../../common/css/color.scss';
.el-popover {
  min-width: 100px;
  background:#1D2C48;
  border: 0;
}
.el-popper {
  .popper__arrow, .popper__arrow:after {
    border-bottom-color: rgba(34, 52, 85, 0.6) !important;
  }
}
.pop-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .el-link.el-link--primary {
    color: $font_color;
    &:hover {
      color: $card_header;
    }
  }
  i {
    margin-right: 10px;
  }
}
.data-table {
  position: relative;
  height: calc(100vh - 40px);
  .el-card {
    border: 0;
    background: transparent;
    border-radius: 0;

    .el-card__header {
      padding: 0 10px;
      height: 40px;
      line-height: 40px;
      background-color: $card_header;
      text-align: left;
      color: $font_color;
      border-bottom: 0;
    }

    .el-card__body {
      padding: 0;
      background: rgba(2, 16, 33, 0.6);
      width: 320px;
      // bottom: 0px;
      height: calc(100vh - 40px);
    }

    .tool-bar {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;

      .r-bar {
        .el-select {
          width: 134px;
          border-radius: 2px;

          .el-input {
            .el-input__icon {
              line-height: 26px;
            }

            .el-input__inner {
              height: 26px;
              line-height: 26px;
              padding: 0 10px;
              border-radius: 2px;
            }
          }
        }

        .el-select:first-child {
          margin-right: 8px;
        }

        .el-select:nth-child(2) {
          margin-right: 10px;
        }

        .btn1 {
          height: 26px;
          // width: 66px;
          padding: 0 5px;
          border-radius: 2px;
          background-color: #2d61a8;
          border: 0;
        }
      }

      .btn2 {
        width: 16px;
        background: transparent;
        padding: 0;
        border-radius: 2px;
        border: 0;
        color: $font_color;
      }
    }

    .el-table {
      height: 100%;

      .btns {
        border: 0;
        padding: 0;
        background: transparent;
        color: #84feff;
      }

      .circ {
        display: inline-block;
        border-radius: 50%;
        width: 14px;
        height: 14px;
        background: #4ACA8A;
      }

      .circ-b {
        display: inline-block;
        border-radius: 50%;
        width: 14px;
        height: 14px;
        background: #F07150;
      }
    }
  }
}
.btn-box {
  display: -webkit-flex; /* Safari */
  display: flex;
  justify-content: space-between;
  padding: 10px;
  align-items: center;
  .sw-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: $font_color;
    p {
      margin-right: 10px;
      font-size: 14px;
    }
  }
  .el-icon-arrow-down{
    margin-right: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mind/dataMonitorTable.vue